import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { DeviceService } from '../services/device.service';
import { Storage } from '@ionic/storage';

@Injectable({
    providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        public toastController: ToastController,
        public deviceService: DeviceService,
        public storage: Storage
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.storage.get('USER_INFO')).pipe(
            switchMap(response => {
                const token = response ? response.access_token : null;

                if (token) {
                    request = request.clone({
                        headers: request.headers.set('Authorization', 'Bearer ' + token)
                    });
                }

                request = request.clone({
                    headers: request.headers.set('Accept', 'application/json')
                });

                return next.handle(request).pipe(
                    map((event: HttpEvent<any>) => event),
                    catchError((error: HttpErrorResponse) => {
                        if (error.status === 401) {
                            this.router.navigate(['login']);
                            this.authState(false);
                        }
                        return throwError(error);
                    })
                );
            })
        );
    }

    private authState(state: boolean) {
        this.deviceService.isLoggedIn = state;
        this.storage.set('USER_INFO', null);
    }

    async presentToast(msg) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 2000,
            position: 'bottom'
        });
        toast.present();
    }
}
